import React from 'react'
import PropTypes from 'prop-types'

import Button from '../ui/Button';
import RadioButtonContainer from '../ui/RadioButtonContainer';
import { sendAnalyticsEventToNative } from '../utils/analytics';

class Confirm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      successUseData: false,
      errorValid: false
    }
  }

  componentDidMount(){
    sendAnalyticsEventToNative('ecoCreditCardOrderStep4')
  }

  submit = e => {
    e.preventDefault()
    if (this.validation()) {
      const formData = {}
      formData.clientApprove = true

      this.props.onSubmitData(formData)
    } else
      this.setState({
        errorValid: true
      })
  }
  validation = () => !!this.state.successUseData

  onCheckRadio = () => this.setState({ successUseData: true })

  render() {
    const { errorValid, successUseData } = this.state

    return (
      <form className="work-information" onSubmit={this.submit}>
        <div className="scroll-container">
          <div className="work-info">
            <div className={`form-radiobutton-container ${errorValid && !successUseData && 'error-validation'}`}>
              <RadioButtonContainer
                title=''
                name='successUseData'
                // eslint-disable-next-line max-len
                data={[{ id: 'true', title: "Погоджуюсь з умовами кредитування, а також даю дозвіл на передачу даних, перевірку в БКІ і кредитний реєстр. Дозволяю зберігати та обробляти дані. Надаю згоду Банку отримувати у оператора електронних комунікаційних послуг, що надає мені послуги мобільного зв’язку та оброблює дані, що пов'язані з наданням таких послуг, інформацію про надані мені телекомунікаційні послуги, з метою отримання інформації щодо оцінки моєї телекомунікаційної поведінки для подальшої обробки даних в Банку. Одночасно, надаю згоду відповідному оператору електронних комунікаційних послуг на обробку та передачу Банку такої інформації." }]}
                onChange={this.onCheckRadio}
                checked={`${successUseData}`}
              />
            </div>
          </div>
          <div className='button-container-footer'>
            <Button
              type='submit'
              title='Відправити'
              color={this.validation() ? 'success' : 'disable'}
            />
          </div>
        </div>
      </form>
    )
  }
}

Confirm.propTypes = {
  onSubmitData: PropTypes.func.isRequired,
}

export default Confirm